
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire405b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire405b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $f8d1325030bf6a5c$exports = {};
$parcel$extendImportMap({
    "4m0ZO": "IMG_5602.5f15ddc9.jpeg",
    "8o5zO": "IMG_5604.20a9bdde.jpeg",
    "eUU8Z": "featherfeautre.b71b9e06.jpg",
    "jvoLq": "0D332444-5C87-42F4-B5CA-A7AA7CFAD58F.e4888ded.jpeg",
    "kkH1j": "0e121a9c-5ae8-41ea-9912-859450ea0a67.110a80aa.jpeg",
    "f1uL7": "0EE41B55-8140-4393-A3C0-EBF3E078D148.b5ea9f37.jpeg",
    "d3JQm": "0ef3686c-af5c-4a28-844c-36cf07440113.aafd0b3f.jpeg",
    "6ehyp": "0F510795-04CD-44A5-B0B0-0AF58E678195.ed98181c.jpeg",
    "eUhLn": "086a2df1-ab0b-4716-b30b-6e85673e5525.d35df0dc.jpeg",
    "1FgK8": "2a12fc93-8db8-411b-8a11-fa4486e73ec6.fd9f0f55.jpeg",
    "hCFx8": "2ae15c9e-e5bc-4e09-baea-d267342529d2.c4e77782.jpeg",
    "2JWcm": "2F8E6853-2497-4709-87FA-C5D015739FBF.d5ecce83.jpeg",
    "9kutj": "3b649a1b-d722-4570-87c4-76eda0f6ea01.5ee02d4a.jpeg",
    "1SnFk": "3cb8a7ee-1528-4533-a03d-4591e22cdd60.1a7cb5b4.jpeg",
    "cLqup": "3ff14fde-2d90-439e-bb86-86709bd87278.4f95cebe.jpeg",
    "fQzrh": "4BDFDBF9-B48C-4349-A508-3A85DA0427CF.91327005.jpeg",
    "l06XB": "6d65a088-04ac-4ced-a8d7-aaba188789cc.8899350b.jpeg",
    "16yY9": "14b87429-9ed4-494e-a3aa-79b52ffa12dd.3d3fd243.jpeg",
    "5vC40": "71a5b125-2760-4baa-93aa-8dcc58795a67.f5595b33.jpeg",
    "2qR1X": "296a97f3-da3a-45ae-abf7-df93e6a43ad6.d358fabb.jpeg",
    "jr7YY": "962fdbf1-85e4-49c4-bcf4-8d8e0c8f4e3f.cdd7c907.jpeg",
    "2QeoD": "6463ae67-e104-4c94-8157-3a5585c8d00b.9b689f41.jpeg",
    "i8LqY": "9622f86f-c3bf-480d-ac8b-0b63b866fa66.da7af704.jpeg",
    "18L1G": "321111d8-05c7-4085-bed0-e03c7d3e0413.dee0b15c.jpeg",
    "64pdq": "1674626c-58c0-4c0b-8ef9-67421eb93ffd.bcc65816.jpeg",
    "9K2xV": "997554732305667332.857fbe18.jpeg",
    "4tW8U": "2516426713522933014.54436cab.jpeg",
    "hCg1K": "3929062271793101592.143fb053.jpeg",
    "hWlBX": "4889895707960879218.4779765c.jpeg",
    "55GJk": "6782551657763913384.7712fc69.jpeg",
    "ibWR0": "A200DD6A-1F72-477F-AF3F-E0012057C2E9.17626cb7.jpeg",
    "d1Io1": "a86494d9-ff12-4165-9cf3-fbff101f1cb7.d2efdcb2.jpeg",
    "lJIIn": "b3b4b64c-4e75-48c4-ba92-e9fc8fb2aab1.8f061f59.jpeg",
    "7zaf4": "b6a500f0-b625-4152-8efd-210d630283e4.79e6f333.jpeg",
    "hIzRP": "dabac9a5-734d-410e-9cf3-1cee99d65d4a.171d17ef.jpeg",
    "5o48s": "e7ef49a5-724d-4c60-ad45-b0395eb11d41.57f34a43.jpeg",
    "gUyNS": "eca7d628-e7ee-4c4a-8b45-d6331fc1aeee.80d36f0e.jpeg",
    "c1AxU": "f0b7ed0d-62ff-4c20-af34-19b83d298cea.4a6a4eda.jpeg",
    "66FoK": "F2B92435-400B-4F23-BC94-92EDAB9AAA17.ec809f1f.jpeg",
    "jS8NT": "ff4b264b-e692-4d01-a249-21d919db9f87.f8a2df25.jpeg",
    "cAtmR": "IMG_0494.032e2c59.jpeg",
    "7oSAT": "IMG_2499.b74a4269.jpeg",
    "bSdDQ": "IMG_3346.fc8bd303.jpeg",
    "3HEUp": "IMG_3571.e9f29eb8.jpeg",
    "lgpgm": "IMG_3636.1999a4d8.jpeg",
    "dmaZA": "IMG_4930.39c6d2ca.jpeg",
    "ken8d": "IMG_4954.6e590d41.jpeg",
    "69ZyR": "IMG_7431.2e8e33df.jpeg"
});

var $783c720b35050d3c$exports = {};
$783c720b35050d3c$exports = $parcel$resolve("4m0ZO");


var $1ae73b830b7a1e9c$exports = {};
$1ae73b830b7a1e9c$exports = $parcel$resolve("8o5zO");


var $a5392ae661d57856$exports = {};
$a5392ae661d57856$exports = $parcel$resolve("eUU8Z");


var $09c7860d857b213a$exports = {};
$09c7860d857b213a$exports = $parcel$resolve("jvoLq");


var $bb09311916ad331b$exports = {};
$bb09311916ad331b$exports = $parcel$resolve("kkH1j");


var $28d31d63eb5b34f2$exports = {};
$28d31d63eb5b34f2$exports = $parcel$resolve("f1uL7");


var $70636df999b7a8e6$exports = {};
$70636df999b7a8e6$exports = $parcel$resolve("d3JQm");


var $964e8bb5d2c46f41$exports = {};
$964e8bb5d2c46f41$exports = $parcel$resolve("6ehyp");


var $69636b8b801f8d88$exports = {};
$69636b8b801f8d88$exports = $parcel$resolve("eUhLn");


var $443a0ffee967eb77$exports = {};
$443a0ffee967eb77$exports = $parcel$resolve("1FgK8");


var $3768e3b7eeb010af$exports = {};
$3768e3b7eeb010af$exports = $parcel$resolve("hCFx8");


var $9a8e1d5f95101f82$exports = {};
$9a8e1d5f95101f82$exports = $parcel$resolve("2JWcm");


var $204779769d2c01f6$exports = {};
$204779769d2c01f6$exports = $parcel$resolve("9kutj");


var $20c1625ae767413c$exports = {};
$20c1625ae767413c$exports = $parcel$resolve("1SnFk");


var $63afcb83f9afa89d$exports = {};
$63afcb83f9afa89d$exports = $parcel$resolve("cLqup");


var $22cba09f5b43ea25$exports = {};
$22cba09f5b43ea25$exports = $parcel$resolve("fQzrh");


var $dbebe1cd4d206fe9$exports = {};
$dbebe1cd4d206fe9$exports = $parcel$resolve("l06XB");


var $abdcfb28d7d6d682$exports = {};
$abdcfb28d7d6d682$exports = $parcel$resolve("16yY9");


var $9bb8f907bf2d6f6a$exports = {};
$9bb8f907bf2d6f6a$exports = $parcel$resolve("5vC40");


var $cfcba0da907408f3$exports = {};
$cfcba0da907408f3$exports = $parcel$resolve("2qR1X");


var $236288b65ba45450$exports = {};
$236288b65ba45450$exports = $parcel$resolve("jr7YY");


var $c62bdef09d83ad75$exports = {};
$c62bdef09d83ad75$exports = $parcel$resolve("2QeoD");


var $d95cc0adfe36dbae$exports = {};
$d95cc0adfe36dbae$exports = $parcel$resolve("i8LqY");


var $a5d878a1360964eb$exports = {};
$a5d878a1360964eb$exports = $parcel$resolve("18L1G");


var $665a7cbe3687969c$exports = {};
$665a7cbe3687969c$exports = $parcel$resolve("64pdq");


var $a7ed0e565da3575a$exports = {};
$a7ed0e565da3575a$exports = $parcel$resolve("9K2xV");


var $5da038dcf1fbef4f$exports = {};
$5da038dcf1fbef4f$exports = $parcel$resolve("4tW8U");


var $2d14befc75cb8340$exports = {};
$2d14befc75cb8340$exports = $parcel$resolve("hCg1K");


var $9b55adb1ad2d351d$exports = {};
$9b55adb1ad2d351d$exports = $parcel$resolve("hWlBX");


var $b3e01acd233d2812$exports = {};
$b3e01acd233d2812$exports = $parcel$resolve("55GJk");


var $55c2ecb39737ed06$exports = {};
$55c2ecb39737ed06$exports = $parcel$resolve("ibWR0");


var $99a978b1c1b7ed57$exports = {};
$99a978b1c1b7ed57$exports = $parcel$resolve("d1Io1");


var $5123e9fde24cd546$exports = {};
$5123e9fde24cd546$exports = $parcel$resolve("lJIIn");


var $85b7158799759d83$exports = {};
$85b7158799759d83$exports = $parcel$resolve("7zaf4");


var $5861fae913ed3782$exports = {};
$5861fae913ed3782$exports = $parcel$resolve("hIzRP");


var $b1e90201e7421fc1$exports = {};
$b1e90201e7421fc1$exports = $parcel$resolve("5o48s");


var $40e0fa8272c9c0dd$exports = {};
$40e0fa8272c9c0dd$exports = $parcel$resolve("gUyNS");


var $dcd944bbca93a22e$exports = {};
$dcd944bbca93a22e$exports = $parcel$resolve("c1AxU");


var $80aa1d2e132e265d$exports = {};
$80aa1d2e132e265d$exports = $parcel$resolve("66FoK");


var $8cea051d09166b5f$exports = {};
$8cea051d09166b5f$exports = $parcel$resolve("jS8NT");


var $ccd1e37e256698f2$exports = {};
$ccd1e37e256698f2$exports = $parcel$resolve("cAtmR");


var $1f2f04695240495d$exports = {};
$1f2f04695240495d$exports = $parcel$resolve("7oSAT");


var $eb773c2221edb899$exports = {};
$eb773c2221edb899$exports = $parcel$resolve("bSdDQ");


var $251ef689d9b8e267$exports = {};
$251ef689d9b8e267$exports = $parcel$resolve("3HEUp");


var $41a2cfee4dda3936$exports = {};
$41a2cfee4dda3936$exports = $parcel$resolve("lgpgm");


var $8b6f25546ac5f7f7$exports = {};
$8b6f25546ac5f7f7$exports = $parcel$resolve("dmaZA");


var $8d874332fbefb707$exports = {};
$8d874332fbefb707$exports = $parcel$resolve("ken8d");


var $c1fd5f4903a2a5f9$exports = {};
$c1fd5f4903a2a5f9$exports = $parcel$resolve("69ZyR");


let $10a3390e9c80f861$var$pics = [
    new URL($783c720b35050d3c$exports),
    new URL($1ae73b830b7a1e9c$exports),
    new URL($a5392ae661d57856$exports),
    new URL($09c7860d857b213a$exports),
    new URL($bb09311916ad331b$exports),
    new URL($28d31d63eb5b34f2$exports),
    new URL($70636df999b7a8e6$exports),
    new URL($964e8bb5d2c46f41$exports),
    new URL($69636b8b801f8d88$exports),
    new URL($443a0ffee967eb77$exports),
    new URL($3768e3b7eeb010af$exports),
    new URL($9a8e1d5f95101f82$exports),
    new URL($204779769d2c01f6$exports),
    new URL($20c1625ae767413c$exports),
    new URL($63afcb83f9afa89d$exports),
    new URL($22cba09f5b43ea25$exports),
    new URL($dbebe1cd4d206fe9$exports),
    new URL($abdcfb28d7d6d682$exports),
    new URL($9bb8f907bf2d6f6a$exports),
    new URL($cfcba0da907408f3$exports),
    new URL($236288b65ba45450$exports),
    new URL($c62bdef09d83ad75$exports),
    new URL($d95cc0adfe36dbae$exports),
    new URL($a5d878a1360964eb$exports),
    new URL($665a7cbe3687969c$exports),
    new URL($a7ed0e565da3575a$exports),
    new URL($5da038dcf1fbef4f$exports),
    new URL($2d14befc75cb8340$exports),
    new URL($9b55adb1ad2d351d$exports),
    new URL($b3e01acd233d2812$exports),
    new URL($55c2ecb39737ed06$exports),
    new URL($99a978b1c1b7ed57$exports),
    new URL($5123e9fde24cd546$exports),
    new URL($85b7158799759d83$exports),
    new URL($5861fae913ed3782$exports),
    new URL($b1e90201e7421fc1$exports),
    new URL($40e0fa8272c9c0dd$exports),
    new URL($dcd944bbca93a22e$exports),
    new URL($80aa1d2e132e265d$exports),
    new URL($8cea051d09166b5f$exports),
    new URL($ccd1e37e256698f2$exports),
    new URL($1f2f04695240495d$exports),
    new URL($eb773c2221edb899$exports),
    new URL($251ef689d9b8e267$exports),
    new URL($41a2cfee4dda3936$exports),
    new URL($8b6f25546ac5f7f7$exports),
    new URL($8d874332fbefb707$exports),
    new URL($c1fd5f4903a2a5f9$exports)
];
var $10a3390e9c80f861$export$2e2bcd8739ae039 = $10a3390e9c80f861$var$pics;


let $f6ff524e3096d871$var$idx = 0;
let $f6ff524e3096d871$var$loaded = new Array((0, $10a3390e9c80f861$export$2e2bcd8739ae039).length).fill(false);
let $f6ff524e3096d871$var$autoFade = ()=>{
    if (!$f6ff524e3096d871$var$loaded[$f6ff524e3096d871$var$idx]) {
        let carouselElem = document.createElement("div");
        // imageElem.style.display = "none";
        carouselElem.classList = "w-full flex flex-col justify-center items-center overflow-auto h-128 hidden";
        let elemTxt = `
<!-- Full-width images with number and caption text -->

    <!-- <div class="">${$f6ff524e3096d871$var$idx + 1} / ${(0, $10a3390e9c80f861$export$2e2bcd8739ae039).length}</div> -->
    <img src=${(0, $10a3390e9c80f861$export$2e2bcd8739ae039)[$f6ff524e3096d871$var$idx].toString()} class="w-full h-full object-contain rounded-lg">
`;
        carouselElem.innerHTML = elemTxt;
        document.querySelector("#carousel").appendChild(carouselElem);
        $f6ff524e3096d871$var$loaded[$f6ff524e3096d871$var$idx] = true;
    }
    let carouselContainer = document.querySelector("#carousel");
    for (let elem of carouselContainer.children){
        elem.classList.remove("hidden");
        elem.classList.add("hidden");
    }
    carouselContainer.children[$f6ff524e3096d871$var$idx].classList.remove("hidden");
    $f6ff524e3096d871$var$idx++;
    $f6ff524e3096d871$var$idx = $f6ff524e3096d871$var$idx % (0, $10a3390e9c80f861$export$2e2bcd8739ae039).length;
};
let $f6ff524e3096d871$export$2cd8252107eb640b = ()=>{
    $f6ff524e3096d871$var$autoFade();
    setInterval($f6ff524e3096d871$var$autoFade, 2000);
};


let $db0490e283c67751$var$drawerExpanded = false;
let $db0490e283c67751$export$aba0aa5587fcb962 = ()=>{
    let drawer = document.querySelector("#drawer");
    if ($db0490e283c67751$var$drawerExpanded) drawer.style.right = "-" + drawer.clientWidth + "px";
    else drawer.style.right = "0px";
    $db0490e283c67751$var$drawerExpanded = !$db0490e283c67751$var$drawerExpanded;
};


/* When the user scrolls down, hide the navbar. When the user scrolls up, show the navbar */ let $1e6a16da88d577c6$var$prevScrollpos = window.pageYOffset;
let $1e6a16da88d577c6$var$topnav = document.querySelector("#topnav");
addEventListener("scroll", ()=>{
    let currentScrollPos = window.pageYOffset;
    // let navsize = document.querySelector("nav")!.offsetHeight;
    if ($1e6a16da88d577c6$var$prevScrollpos > currentScrollPos) $1e6a16da88d577c6$var$topnav.style.top = "0";
    else $1e6a16da88d577c6$var$topnav.style.top = "-" + $1e6a16da88d577c6$var$topnav.clientHeight + "px";
    $1e6a16da88d577c6$var$prevScrollpos = currentScrollPos;
}, true);
let $1e6a16da88d577c6$var$drawerButton = document.querySelector("#menu");
$1e6a16da88d577c6$var$drawerButton.addEventListener("click", (0, $db0490e283c67751$export$aba0aa5587fcb962));
let $1e6a16da88d577c6$var$drawer = document.querySelector("#drawer");
$1e6a16da88d577c6$var$drawer.style.top = "" + $1e6a16da88d577c6$var$topnav.clientHeight + "px";
$1e6a16da88d577c6$var$drawer.style.right = "-" + $1e6a16da88d577c6$var$drawer.clientWidth + "px";
let $1e6a16da88d577c6$var$drawerButtons = document.querySelectorAll(".drawer-buttons");
for (let button of $1e6a16da88d577c6$var$drawerButtons)button.addEventListener("click", (0, $db0490e283c67751$export$aba0aa5587fcb962));
(0, $f6ff524e3096d871$export$2cd8252107eb640b)();


//# sourceMappingURL=repo.fdd2ce84.js.map
